// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"549":"6460df42","600":"06bc0e29","781":"326585b4"}[chunkId] + ".chunk.js";
};